module.exports = __webpack_public_path__ + "static/subset-UniNeueBook-Italic-83eda647eb176eb58c1f06e5b14374d0.woff2";